import * as React from 'react';
export default function SvgIndentRight() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.75A.75.75 0 014.75 5h8.5a.75.75 0 010 1.5h-8.5A.75.75 0 014 5.75zM4 9.75A.75.75 0 014.75 9h5.5a.75.75 0 010 1.5h-5.5A.75.75 0 014 9.75zM19.8 8.24a.75.75 0 01-.04 1.06L16.852 12l2.908 2.7a.75.75 0 11-1.02 1.1l-3.5-3.25a.75.75 0 010-1.1l3.5-3.25a.75.75 0 011.06.04zM4 18.25a.75.75 0 01.75-.75h8.5a.75.75 0 010 1.5h-8.5a.75.75 0 01-.75-.75zM4 14.25a.75.75 0 01.75-.75h5.5a.75.75 0 010 1.5h-5.5a.75.75 0 01-.75-.75z",
    fill: "currentColor"
  }));
}